import { Injectable }             from '@angular/core';
import { Http, Response }         from '@angular/http';
import { Observable }             from 'rxjs/Observable';
import { ConfigService }          from '../configuracion/config.service';
import { RequestBaseService }     from '../request-base/request-base.service';
import { JwtHttp, AuthService }   from 'ng2-ui-auth';
import { ResponseContentType }    from '@angular/http';

import 'rxjs/add/operator/map';

@Injectable()
export class BproyectoService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
    ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'bproyecto'].join('/');
  }

  public order(fechas) {
    return this.http
    .get([this.ApiUrl,'order',fechas].join('/'))
    .map(res => res.json());
  }

  public orderf(id, orden) {
    return this.http
    .get([this.ApiUrl,'orderf',id, orden].join('/'))
    .map(res => res.json());
  }

  public getExportarHecho(id) {
    this.validate();
    return this.http
      .get([
        this.ApiUrl,id,'exportar'].join('/'), { responseType: ResponseContentType.Blob });
  }




}



// WEBPACK FOOTER //
// ./src/app/services/bproyecto/bproyecto.service.ts